import { Component, Input } from '@angular/core';
import { ElementData, MainAnnex } from '@app/core/models/courses.model';
import { AppSelectors } from '@app/store';
import { AppState } from '@app/store/app.state';
import { Store } from '@ngrx/store';
import { Observable, switchMap, tap } from 'rxjs';

@Component({
  selector: 'app-flip-card',
  templateUrl: './flip-card.component.html',
  styles: [],
  standalone: false,
})
export class FlipCardComponent {
  @Input() public element: ElementData;
  @Input() public fullWidth = false;
  @Input() public fullSize = false;

  public token$: Observable<string>;

  constructor(private _store: Store<AppState>) {
    this.token$ = this._store.select(AppSelectors.token);
  }

  public urlFlip(anexo: MainAnnex, token: string): string {
    return `${anexo.flip}?frame=1&t=${token}&ta=1`;
  }
}
